import { OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GLOBAL } from 'src/app/services/global';
var MesonOnlineComponent = /** @class */ (function () {
    function MesonOnlineComponent(toastr) {
        this.toastr = toastr;
        this.correos = GLOBAL.correos;
    }
    MesonOnlineComponent.prototype.ngOnInit = function () {
    };
    MesonOnlineComponent.prototype.copyToClipboard = function (element) {
        var aux = document.createElement("input");
        aux.setAttribute("value", element);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand("copy");
        document.body.removeChild(aux);
        this.toastr.success('Listo!', 'Email copiado al portapapeles');
    };
    return MesonOnlineComponent;
}());
export { MesonOnlineComponent };
